<kendo-daterange class="range-contain" >
  <div class="dateContain">


      <kendo-floatinglabel [text]="param.rangeOptions.startTitle">
        <kendo-dateinput kendoDateRangeStartInput [(value)]="start" id="start" [format]="param.format" style="width: 168px;" ></kendo-dateinput>
    </kendo-floatinglabel>

</div>

  <div class="dateContain">



    <kendo-floatinglabel [text]="param.rangeOptions.endTitle">
    <kendo-dateinput kendoDateRangeEndInput [(value)]="end" id="end" [format]="param.format" style="width: 168px;"></kendo-dateinput>
    </kendo-floatinglabel>
  </div>
</kendo-daterange>
